import React from 'react';
import { Typography } from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { getAlertColor, getAlertLabelDisplay, getAlertValue } from '../helpers/dashboardHelpers';



interface AlertWidgetProps {
    userRoles: any,
    currentValue: number,
    redAlert: number | null,
    yellowAlert: number | null,
    isItAbove: boolean
}


const AlertWidget: React.FC<AlertWidgetProps> = ({
    userRoles,
    currentValue,
    redAlert,
    yellowAlert,
    isItAbove
}) => {
    return (
        <>
          <Typography variant="h3" style={{
                fontWeight: "bold",
                width: "fit-content",
                padding: 5,
                marginTop: 5,
                marginLeft: 'auto',
                marginRight: 'auto',
                backgroundColor: getAlertColor(userRoles, currentValue, redAlert, yellowAlert, isItAbove),
                display: getAlertLabelDisplay(currentValue, redAlert, yellowAlert, isItAbove),
                color: "#00152E"
                }}>
                <ReportProblemOutlinedIcon style={{ fontSize: '16px', verticalAlign: "middle" }} /> 
                {isItAbove?'Above':'Below'} KPI of {getAlertValue(currentValue, redAlert, yellowAlert, isItAbove)}
            </Typography>
        </>
    );
}

export default AlertWidget;